<template>
    <b-card class="p-2" no-body>
        <div v-if="treeItem.children && !treeItem.children.length" class="text-center my-5">
            <b-icon icon="exclamation-circle-fill" variant="danger" font-scale="2" />
            <p class="mt-2">No layers found</p>
        </div>
        <component :is="getComponent(treeItem.type)" v-else :tree-item="treeItem" />
    </b-card>
</template>

<script lang="ts" setup>
import { Component } from 'vue';
import { TreeItem, TreeType } from '@/components/Layers/modal/types';
import ModalImportLayersTreeItemExternal from './ModalImportLayersTreeItemExternal.vue';
import ModalImportLayersTreeItem from './ModalImportLayersTreeItem.vue';

defineProps<{
    treeItem: TreeItem;
}>();

const getComponent = (treeItemType: TreeType) => {
    const components: Record<string, Component> = {
        [TreeType.FROM_FILE_ELEMENT]: ModalImportLayersTreeItemExternal,
        ['default']: ModalImportLayersTreeItem
    };
    return components[treeItemType] || components['default'];
};
</script>
